import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getColorList = createAsyncThunk(
  "get-color",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("color/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createColor = createAsyncThunk(
  "create-color",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("color", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editColor = createAsyncThunk(
  "edit-color",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`color/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateColor = createAsyncThunk(
  "update-color",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/color/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteColor = createAsyncThunk(
  "delete-color",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/color/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const colorSlice = createSlice({
  name: "color",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getColorList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getColorList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.colorList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getColorList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default colorSlice.reducer;
